// CYRA color map — injected before variant-picker runs
(function() {
  var CYRA_COLORS = {
    'ivory':      '#F5F0E4',
    'black':      '#000000',
    'onyx':       '#000000',
    'sandstone':  '#b09089',
    'cocoa':      '#6B4836',
    'bloom pink': '#F4A7B9'
  };

  function patchSwatches() {
    if (!window.MinimogSettings) return;
    if (!window.MinimogSettings._colorSwatches) {
      window.MinimogSettings._colorSwatches = [];
    }
    Object.keys(CYRA_COLORS).forEach(function(key) {
      var idx = window.MinimogSettings._colorSwatches.findIndex(function(s) {
        return s.key === key;
      });
      if (idx > -1) {
        window.MinimogSettings._colorSwatches[idx].value = CYRA_COLORS[key];
      } else {
        window.MinimogSettings._colorSwatches.push({ key: key, value: CYRA_COLORS[key] });
      }
    });
  }

  patchSwatches();

  var _orig = window.__setSwatchesOptions;
  window.__setSwatchesOptions = function() {
    if (_orig) _orig.apply(this, arguments);
    patchSwatches();
  };

  var observer = new MutationObserver(function() {
    document.querySelectorAll('.m-product-option--node').forEach(function(node) {
      var val = (node.dataset.value || '').toLowerCase().trim();
      if (CYRA_COLORS[val]) {
        var label = node.querySelector('label');
        if (label && !label.dataset.cyraPatched) {
          label.style.setProperty('background-color', CYRA_COLORS[val], 'important');
          label.style.setProperty('background-image', 'none', 'important');
          label.dataset.cyraPatched = '1';
        }
      }
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });

  window.addEventListener('load', function() {
    patchSwatches();
    document.querySelectorAll('.m-product-option--node').forEach(function(node) {
      var val = (node.dataset.value || '').toLowerCase().trim();
      if (CYRA_COLORS[val]) {
        var label = node.querySelector('label');
        if (label) {
          label.style.setProperty('background-color', CYRA_COLORS[val], 'important');
          label.style.setProperty('background-image', 'none', 'important');
        }
      }
    });
  });
})();
